const elementEdgesVisible = (el, skewFromBottom) => {
  if (el) {
    const rect = el.getBoundingClientRect();
    const { bottom } = rect;
    const windowHeight =
      window.innerHeight || document.documentElement.clientHeight;

    if (skewFromBottom) {
      return bottom <= windowHeight;
    }

    return bottom <= 0;
  }

  return false;
};

export default elementEdgesVisible;
